import * as React from 'react';
import styled from 'styled-components';
import phone1 from 'assets/img/landing/phone.png';
import phone2 from 'assets/img/landing/phone2.png';
import mPhone1 from 'assets/img/landing/m_phone.png';

import section_bg from 'assets/img/landing/prize_bg.svg';
import offerSectionBg from 'assets/img/landing/BetMGMOfferBackgound.png';

import bww_logo from 'assets/img/landing/cards/bww.svg';
import bet_mgm_logo from 'apps/BWW_PLAY_HUB/assets/img/bet_mgm.png';
import { useScrollToID } from 'modules/hooks';

const mobileBreakPoint = '1000px';

const Wrapper = styled.div`
  background: #FFC600 url(${section_bg}) no-repeat 80% 0;
  width: 100%;
  display: flex;
  padding: 35px 20px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;

  @media (min-width: 1200px) {
	flex-direction: row;
	text-align: left;
	padding: 63px 12px 0;
	height: 530px;
  }

  @media screen and (max-width: ${mobileBreakPoint}) {
	flex-direction: column;
	padding: 25px 20px 0 20px;
  }
`;


const LeftSection = styled.img`
  width: 223px;
  margin-bottom: 25px;
  position: relative;
  left: -12px;

  @media (min-width: 1200px) {
	width: 628px;
	margin-bottom: 0;
  }

  @media screen and (max-width: ${mobileBreakPoint}) {
	display: none;
	margin-bottom: 0;
  }
`;

const RightSection = styled.img`
  width: 223px;
  margin-bottom: 65px;
  @media (min-width: 1200px) {
	width: 280px;
	margin-top: -62px;
  }
  @media screen and (max-width: ${mobileBreakPoint}) {
	display: none;
  }
`;

const MobileImages = styled.div`
  display: none;

  @media screen and (max-width: ${mobileBreakPoint}) {
	display: flex;
	margin-top: 36px;
	${LeftSection}, ${RightSection} {
	  position: relative;
	  display: block;
	  height: 450px;
	  width: unset;
	  left: unset;
	  margin-bottom: 0;
	}

	${LeftSection} {
	  left: 12px;
	}

	${RightSection} {
	  left: 12px;
	  width: auto;
	  bottom: 32px;
	  transform: scale(0.9);
	}
  }
`

const Title = styled.div`
  color: #38312D;
  font-family: Champion, sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 10px;
  text-align: center;

  @media (min-width: 1200px) {
	font-size: 50px;
	line-height: 45px;
	margin-bottom: 45px;
  }
`;

const Text = styled.div`
  font-family: 'Eund', sans-serif;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  padding: 0 18px;
  text-align: center;

  @media (min-width: 1200px) {
	font-size: 20px;
	line-height: 25px;
  }
`;

const TextWrapper = styled.div`
  position: relative;
  right: -18px;
  padding: 0 32px;

  @media screen and (max-width: ${mobileBreakPoint}) {
	right: unset;
	padding: 0;

	${Title} {
	  font-family: Barlow, sans-serif;
	  font-size: 24px;
	  font-weight: 600;
	  letter-spacing: 0;
	  line-height: 25px;
	  text-align: center;
	  margin-bottom: 20px;
	}

	${Text} {
	  font-family: 'Eund', sans-serif;
	  font-size: 14px;
	  letter-spacing: 0;
	  line-height: 16px;
	  text-align: center;
	  padding: 0;
	}
  }
`

export const MGMSection: React.FC = () => (
	<React.Fragment>
		<BetMGMOfferSection/>
		<BetMGMPhoneSection/>
	</React.Fragment>
);

const BetMGMPhoneSection: React.FC = () => (
	<Wrapper>
		<LeftSection src={phone1}/>
		<div>
			<TextWrapper>
				<Title>don’t leave prizes this good on your phone</Title>
				<Text>
					<p>
						Buffalo Wild Wings free-to play games - Picks & Props and Trivia.
					</p>
					<br/>
					<p>
						We’ve partnered with BetMGM to bring you the ultimate challenge for sports fans: Picks and
						Props. The odds based free-to-play parlay game with huge prizes you can compete to win every
						day.
					</p>
					<br/>
					<p>
						Buffalo Wild Wings Trivia is an interactive trivia experience when playing at the bar. Trivia
						questions range across many categories including sports, music, entertainment, recent events,
						and much more!Make sure you're checked in to the Buffalo Wild Wings app to be eligible for
						prizing
					</p>
				</Text>
			</TextWrapper>
		</div>
		<RightSection src={phone2}/>
		<MobileImages>
			<LeftSection src={mPhone1}/>
			<RightSection src={phone2}/>
		</MobileImages>
	</Wrapper>
)

const OfferWrapper = styled.div`
  background: url(${offerSectionBg});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 60px 24px 70px 24px;

  @media screen and (max-width: 1000px) {
	padding: 20px;
  }

	@media screen and (max-width: 780px) {
	background-position: right -30px bottom 0;
  }
`;

const OfferContainer = styled.div`
  display: flex;
  max-width: 850px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  gap: 32px;
  
  @media screen and (max-width: 1000px) {
	align-items: flex-start;
	gap: 12px;
  }
`;

const OfferTitle = styled.h2`
  text-transform: uppercase;
  color: #FFFFFF;
  font-family: Champion, sans-serif;;
  font-size: 49px;
  letter-spacing: 0;
  line-height: 49px;
  text-align: center;
  max-width: 800px;

  @media screen and (max-width: 1000px) {
	color: #FFFFFF;
	font-family: Barlow, sans-serif;
	font-size: 24px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: 25px;
	text-align: left;
	max-width: 230px;
  }
`;

const OfferNote = styled.p`
  color: #FFFFFF;
  font-family: Eund, sans-serif;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
  
  @media screen and (max-width: 1000px) {
	br {
	  display: none;
	}
	
	font-size: 14px;
	letter-spacing: 0;
	line-height: 18px;
	max-width: 210px;
	text-align: left;
  }
`;

const Logos = styled.div`
  height: 62px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;

  img, a {
	display: block;
	height: 100%;
	width: auto;
  }
  
  @media screen and (max-width: 1000px) {
	height: 28px;
	gap: 18px;
  }
`

const PureButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
`;

const Terms = styled.p`
  color: #FFFFFF;
  font-family: Eund, sans-serif;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;

  button {
	color: #FFFFFF;
	text-decoration: underline;
	font-size: 20px;
	letter-spacing: 0;
	line-height: 25px;
  }
  
  @media screen and (max-width: 1000px) {
	font-size: 14px;
	letter-spacing: 0;
	line-height: 18px;
	
	button {
	  font-size: 14px;
	  letter-spacing: 0;
	  line-height: 18px;
	}
  }
`;

const BetMGMOfferSection: React.FC = () => {
	const scrollTo = useScrollToID('mgm-terms');
	return (
		<OfferWrapper>
			<OfferContainer>
				<OfferTitle>
					Check out BetMGM Exclusive Offers Only in Select BWWs Stores
				</OfferTitle>
				<OfferNote>
					BetMGM only available in select legal betting states. <br/>
					More states to be added in the future.
				</OfferNote>
				<Terms>See <PureButton onClick={scrollTo}>terms & conditions</PureButton></Terms>
				<Logos>
					<img src={bww_logo} alt="BWW"/>
					<a href="https://BetMGM.com">
						<img src={bet_mgm_logo} alt="BETMGM"/>
					</a>
				</Logos>
			</OfferContainer>
		</OfferWrapper>
	)
}
